import { type SxProps, type Theme } from "@mui/material";

import type { AdminChatMessage, PlacementChannelMetadata } from "../types";
import { parseCustomMessage } from "../utils/parseCustomMessage";
import { ChatMessageCard } from "./ChatMessageCard";

interface PlacementApplicationInterviewCancelledProps {
  message: AdminChatMessage;
  channelMetadata?: PlacementChannelMetadata;
  sx?: SxProps<Theme>;
}

export function PlacementApplicationInterviewCancelled(
  props: PlacementApplicationInterviewCancelledProps
) {
  const { message, channelMetadata, sx } = props;
  const displayMessage = parseCustomMessage(message.message);

  const workerName = channelMetadata?.hcpName ?? "Worker";

  return (
    <ChatMessageCard
      title="Interview Cancelled"
      subtitle={displayMessage || `${workerName}'s interview has been cancelled by the workplace.`}
      sx={sx}
    />
  );
}
